module.exports = __webpack_public_path__ + "img/icon75.f792b0cd.png";